// extracted by mini-css-extract-plugin
export default {"container":"Sy-z","heading":"Ty-z","text":"Uy-z","info":"Vy-z","link":"Wy-z","fullMaxWidth":"Xy-z"};